package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.MobilePageLayout
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.home.HomeShowcase
import com.arena_web.ui.sections.home.mobile.HomeContentMobile
import com.arena_web.ui.utils.isMobile
import com.arena_web.utils.PageSeo
import com.varabyte.kobweb.core.Page

// Home carries the keyword-rich SEO title/description (Google is mobile-first,
// so the mobile branch must set them too — MobilePageLayout doesn't).
private const val HOME_SEO_TITLE = "Arena Pro Play — Find Players & Pickup Sports Games Near You"
private const val HOME_SEO_DESCRIPTION =
    "Find people nearby to play football, tennis and other sports. " +
        "Join pickup games, create your own events and meet new players in your city with Arena."

@Page("/")
@Composable
fun HomePage() {
    if (isMobile()) {
        PageSeo(title = HOME_SEO_TITLE, description = HOME_SEO_DESCRIPTION)
        MobilePageLayout(
            mobileReady = true,
            // Marketing home sits on a flat black surface — overrides the
            // global body composite (blue tint + noise) for the whole layout
            // including the top bar.
            surfaceColor = "#02040B",
            edgeToEdge = true,
        ) {
            HomeContentMobile()
        }
    } else {
        PageLayout(seoTitle = HOME_SEO_TITLE, description = HOME_SEO_DESCRIPTION) {
            HomeShowcase()
        }
    }
}
